<template>
<widget title="Time-off Settings" class="row-padding">
	<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>
	<vue-form v-on:submit="saveSetting" :no-top-button="true">

		<form-group label="Vacation/Sick Day Reset"
			col-class="col-md-4">

			<div v-if="'CompanySetting' in $store.company" class="d-flex flex-row">
				<field :params="{type:'months-select',placeholder:'Month'}"
					v-model="$store.company.CompanySetting.vacation_reset_month">
				</field>

			<field :params="{type:'select',options:dayOptions,placeholder:'Day'}"
					v-model="$store.company.CompanySetting.vacation_reset_day">
				</field>
			</div>

			<p>This determines the day that vacation/sick day counts rollover</p>

		</form-group>
	</vue-form>
</widget>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import Widget from "@/components/Widget"
import VueForm from "@/components/VueForm"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

export default {
	name: "TimeoffSettings",
	components: {
		Field,
		FormGroup,
		VueForm,
		Widget,
		FreemiumLockedAlert
	},
	computed: {
		dayOptions() {
			let year = this.moment().format("YYYY")
			let daysInMonth = this.moment(year+"-"+this.$store.company.CompanySetting.vacation_reset_month).daysInMonth()

			let days = []
			for (var d = 1; d <= daysInMonth; d++) 
				days.push({value:d,text:d})

			return days
		}
	},
	methods: {
		saveSetting() {
			let vm = this

			let payload = {
				vacation_reset_day: this.$store.company.CompanySetting.vacation_reset_day,
				vacation_reset_month: this.$store.company.CompanySetting.vacation_reset_month
			}

			this.postData("CompanySetting/save",payload,true).then(response => {
				if (response.success)
					vm.alertSaved("Settings saved")
			})
		}
	},
	created() {

	}
}	
</script>